import React, { memo } from 'react';
import { UseFormMethods } from 'react-hook-form';

interface IRHFCheckboxProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label?: string;
    isRequired?: boolean;
    name: string;
    rules?: unknown;
    disabled?: boolean;
    bodyStyle?: React.CSSProperties;
    onClick?: (event?: React.FormEvent<HTMLInputElement>) => void;
    onChange?: (event?: React.ChangeEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
    labelStyle?: React.CSSProperties;
    defaultVal?: string;
    defaultChecked?: boolean;
    checked?: boolean;
    readOnly?: boolean;
    labelOnLeft?: boolean;
}

const RHFCheckboxInner = (props: IRHFCheckboxProps) => {
    if (props.labelOnLeft) {
        return (
            <div className="form-field" style={props.bodyStyle}>
                <label htmlFor={props.name} style={props.labelStyle}>{props.label}</label>
                <input
                    type="checkbox"
                    name={props.name}
                    id={props.name}
                    ref={props.register ? props.register(props.rules) : undefined}
                    className={`field-checkbox ${props.errors?.[props.name] ? 'error-field' : ''}`}
                    disabled={props.disabled || props.readOnly}
                    onClick={props.onClick}
                    onChange={props.onChange}
                    style={!!props.disabled || !!props.readOnly ? { verticalAlign: 'middle', cursor: 'not-allowed', ...props.style } : props.style}
                    checked={props.checked}
                    defaultChecked={props.defaultChecked}
                />
                <br />
                {props.errors?.[props.name] && <p className="error-message">{props.errors?.[props.name]?.message}</p>}
            </div>
        );
    } else {
        return (
            <div className="form-field" style={props.bodyStyle}>
                <input
                    type="checkbox"
                    name={props.name}
                    id={props.name}
                    ref={props.register ? props.register(props.rules) : undefined}
                    className={`field-checkbox ${props.errors?.[props.name] ? 'error-field' : ''}`}
                    disabled={props.disabled || props.readOnly}
                    onClick={props.onClick}
                    onChange={props.onChange}
                    style={!!props.disabled || !!props.readOnly ? { verticalAlign: 'middle', cursor: 'not-allowed', ...props.style } : props.style}
                    checked={props.checked}
                    defaultChecked={props.defaultChecked}
                />
                <label htmlFor={props.name} style={props.labelStyle}>{props.label}</label>
                <br />
                {props.errors?.[props.name] && <p className="error-message">{props.errors?.[props.name]?.message}</p>}
            </div>
        );
    }
};

const RHFCheckbox = memo(RHFCheckboxInner);
export default RHFCheckbox;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFCheckBox.tsx